module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-scary.ad75de44.png";